import { AlertModal, LoadingModal } from './_commons';
import { breakingPoint, sse } from 'src/app-config';
import { changeMobileModeReducer, logoutReducer, refreshUserReducer, setConfigurationReducer } from 'src/store';
import { helpers, userServices } from 'src/services';
import { MainRouter } from 'src/routers/MainRouter';
import { Suspense, useEffect, useState } from 'react';
import { TemporaryNotice } from './_commons/TemporaryNotice';
import { useDispatch } from 'react-redux';
import { useGetAlertModal, useGetIsDarkMode, useGetIsMobile, useGetShowingLoadingModal } from 'src/custom-hooks';
import { useLocation } from 'react-router-dom';

export const App = () => {
    const [refresh, setRefresh] = useState(false);
    const alertModal = useGetAlertModal();
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const location = useLocation();
    const showingLoadingModal = useGetShowingLoadingModal();

    useEffect(() => {
        window.addEventListener('resize', (event: any) => {
            const width: number = event.target.screen.width;
            if ((isMobile && width >= breakingPoint) || (!isMobile && width < breakingPoint)) {
                dispatch(changeMobileModeReducer({ isMobile: width < breakingPoint }));
            }
        });
    }, [dispatch, isMobile]);

    useEffect(() => {
        userServices.GetUserByToken().then(response => {
            if (response.logout) {
                dispatch(logoutReducer());
                return;
            }
            if (!response.user || !response.config) {
                return;
            }
            dispatch(refreshUserReducer(response.user));
            dispatch(setConfigurationReducer(response.config));
        });
    }, [refresh]);

    useEffect(() => {
        helpers.GoToTop();
        if (['casa-en-casa', 'telefonica'].includes(location.pathname)) {
            setRefresh(x => !x);
        }
    }, [location.pathname]);

    useEffect(() => {
        return () => sse.close();
    }, []);

    return (
        <Suspense fallback={(<div>Cargando...</div>)}>
            {isDarkMode &&
                <style>
                    {'.btn-close { background-color: white; }'}
                </style>
            }
            <div style={{ backgroundColor: isDarkMode ? 'black' : 'white' }}>
                <TemporaryNotice />
                {alertModal.showingAlertModal &&
                    <AlertModal />
                }
                {showingLoadingModal &&
                    <LoadingModal />
                }
                <MainRouter />
            </div>
        </Suspense>
    );
}
